"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralGame = void 0;
var change_username_module_1 = require("./apps/referral-game/modules/change-username.module");
var highscore_module_1 = require("./apps/referral-game/modules/highscore.module");
var object_service_1 = require("./object-service");
var ReferralGame = /** @class */ (function () {
    function ReferralGame(settings) {
        var _this = this;
        this.mapping = {
            highscore: highscore_module_1.HighscoreModule,
            changeUsername: change_username_module_1.ChangeUserNameModule
        };
        var dataModules = document.querySelectorAll('[data-module]');
        dataModules.forEach(function (module) {
            var moduleKey = module.getAttribute('data-module');
            console.log('LOAD MODULE', moduleKey);
            object_service_1.ObjectService.getInstance(_this.mapping[moduleKey]).loadModule(module, settings);
        });
    }
    return ReferralGame;
}());
exports.ReferralGame = ReferralGame;
// @ts-ignore
window === null || window === void 0 ? void 0 : window.fittecReferralGame = ReferralGame;
